import { PackageUseProxyFormController } from '../controller/PackageUseProxyFormController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { PackageData } from '../../../types/package-data';
import { Observable } from 'rxjs';
import { ProxyDataResponse } from '../types';
import { PackageActionContext } from '../../types/PackageActionContext';

export class PackageUseProxyFormWebComponent extends BaseWebComponentElement {
  public controller!: PackageUseProxyFormController;
  public packageData: PackageData;
  private companyId: string | undefined;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PackageUseProxyFormController,
    });
  }

  public async companyChangeHandler(): Promise<void> {
    await this.controller.companyChangeHandler();
  }

  public get value(): ProxyDataResponse {
    const formValues: object = this.controller.view.formGroup.value;

    const response: ProxyDataResponse = {
      settings: {
        proxy: {
          enable: formValues['settings']['proxy']['enable'],
        },
      },
    };

    if (response.settings.proxy.enable) {
      response.settings.proxy = formValues['settings']['proxy'];
    }

    return response;
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup?.valid$;
  }

  public get formContext(): PackageActionContext {
    const context = this.getAttribute('context');

    if (!PackageActionContext.isValid(context)) {
      throw new Error(`PackagePanel context not valid: ${context}`);
    }

    return context as PackageActionContext;
  }

  public set formContext(context: PackageActionContext) {
    this.setAttribute('context', context);
  }

  public async setPackageData(packageData: PackageData): Promise<void> {
    this.packageData = packageData;
  }

  public setCompanyId(companyId: string | undefined) {
    this.companyId = companyId;
  }

  public getCompanyId(): string | undefined {
    return this.companyId;
  }

  public get hasUnsavedChanges(): boolean {
    return this.controller.view.formGroup.hasUnsavedChanges;
  }

  public setFormValuesFromDatabase(packageData: PackageData) {
    this.controller.view.setFormValuesFromDatabase(packageData);
  }
}
